export default __webpack_public_path__ + "static/media/skype-color.04b6ed49.svg";